import { useMutation } from "@apollo/client";

import { GqlMapEditorLayerCreateInput, gql } from "~/__generated__";

import { ProjectMapEditorScreen_GetProjectDocument } from "../../project/screens/ProjectMapEditorScreen/queries.generated";
import { MapEditorGetAllLayerFeaturesDocument } from "./useMapEditorGetAllLayerFeatures.generated";

const MAP_EDITOR_LAYER_CREATE = gql(`
    mutation MapEditorLayerCreate($input: GqlMapEditorLayerCreateInput!) {
        mapEditorLayerCreate(input: $input) {
            id
            projectId
            name
            config
            style
            color
            showToClientUser
        }
    }
`);

export default function useMapEditorLayerCreate() {
    const [layerCreate, { data, loading, error }] = useMutation(MAP_EDITOR_LAYER_CREATE, {
        refetchQueries: [MapEditorGetAllLayerFeaturesDocument, ProjectMapEditorScreen_GetProjectDocument],
    });

    return {
        layerCreate: (input: GqlMapEditorLayerCreateInput) =>
            layerCreate({
                variables: {
                    input,
                },
            }),
        loading,
        error,
        data: data?.mapEditorLayerCreate,
    };
}
